import { render, staticRenderFns } from "./Scheduler_menu.vue?vue&type=template&id=08ea7c2a&scoped=true&lang=pug&"
import script from "./Scheduler_menu.vue?vue&type=script&lang=js&"
export * from "./Scheduler_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea7c2a",
  null
  
)

export default component.exports